import React, { useRef, useState } from 'react';
import styled from 'styled-components/macro';
// assets
import { MdArrowDropDown } from 'react-icons/md';
// hooks
import { useOutsideAlerter } from '../hooks';
import { useTranslation } from 'react-i18next';

interface IDropdown {
  mainColor?: any;
  disabled?: boolean;
  onSelectOption?: any;
  options: string[];
  menuStyle?: React.CSSProperties;
  initOption?: string;
}

const DropdownContainer = styled.div`
  border-radius: 6px;
  border: 1px solid ${props => props.theme.colors.secondary[20]};
  min-width: 104px;
  margin-left: 24px;
  padding: 12px 8px;
  height: 40px;
  box-sizing: border-box;
  position: relative;

  @media screen and (max-width: 320px) {
    margin-left: 3px;
  }
`;

const DropDownInput = styled.div`
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const DropDownPlaceholder = styled.div`
  color: ${props => props.theme.colors.secondary[20]};
  font-size: 15px;
  font-weight: normal;
`;

const DropDownMenu = styled.div`
  box-shadow: 0px 6px 16px rgba(29, 30, 36, 0.09);
  background-color: #ffffff;
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  z-index: 3;
  border-radius: 6px;
`;

const DropDownOption = styled.div<{ mainColor?: string }>`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  &:hover {
    background-color: #f2f4f6;
    color: ${({ theme, mainColor }) => mainColor || theme.colors.primary[100]};
  }
`;

export const Dropdown = (props: IDropdown) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const dropdownContainerRef = useRef(null);
  useOutsideAlerter(dropdownContainerRef, () => setIsMenuOpen(false));
  const { t } = useTranslation();

  return (
    <DropdownContainer ref={dropdownContainerRef}>
      <DropDownInput
        style={{ ...(props.disabled && { cursor: 'default' }) }}
        onClick={() => {
          if (!props.disabled) setIsMenuOpen(!isMenuOpen);
        }}
      >
        {props.disabled ? (
          <DropDownPlaceholder>{props.initOption}</DropDownPlaceholder>
        ) : (
          <DropDownPlaceholder
            style={{ ...(selectedOption && { color: '#272A32' }) }}
          >
            {selectedOption ? selectedOption : t('Select...')}
          </DropDownPlaceholder>
        )}

        <MdArrowDropDown
          transform={isMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
        />
      </DropDownInput>
      <DropDownMenu
        style={{ ...(!isMenuOpen && { display: 'none' }), ...props.menuStyle }}
      >
        {props.options.map((opt: string, index: number) => (
          <DropDownOption
            mainColor={props.mainColor}
            key={index}
            onClick={(e: React.MouseEvent<HTMLDivElement>) => {
              props.onSelectOption(e);
              setIsMenuOpen(false);
              setSelectedOption(opt);
            }}
          >
            {opt}
          </DropDownOption>
        ))}
      </DropDownMenu>
    </DropdownContainer>
  );
};
